import Styled from "styled-components";

export const Container = Styled.div`
  padding: 2rem 0 0 0;
`;

export const Content = Styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.25rem;
  width: ${(props) => props.theme.width};
  max-width: calc(100% - 2.5rem);
  margin: 0 auto;
  overflow: hidden;

  ${(props) => props.theme.breakpoints.up("medium")} {
    max-width: calc(100% - 3rem);
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    max-width: calc(100% - 10rem);
  }
`;

export const Message = Styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  border: 1px solid rgb(226, 226, 226);
  border-radius: 1.25rem;
  background: rgb(250, 250, 250);
  padding: 1.875rem 2.5rem;
  color: #030303;

  ${(props) => props.theme.breakpoints.up("medium")} {
    padding: 3.125rem 5rem;
  }
`;

export const Description = Styled.div`
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.5rem;
  letter-spacing: -0.2px;
`;

export const LinksContainer = Styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 1.25rem;
`;

export const Link = Styled.a`
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.25rem;
  letter-spacing: -0.2px;
  text-decoration: none;
  color: #030303;
  transition: all 0.3s ease 0s;
  cursor: pointer;

  :hover, :focus, :active {
    color: ${(props) => props.theme.colors.blue500};
  }
`;
